import { render, staticRenderFns } from "./ModalFornecedores.vue?vue&type=template&id=71dd3ef0&"
import script from "./ModalFornecedores.vue?vue&type=script&lang=js&"
export * from "./ModalFornecedores.vue?vue&type=script&lang=js&"
import style0 from "./ModalFornecedores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports